const translations = {
  // Navigation
  'home': "முகப்பு",
  "detailed": "விரிவான வாழ்க்கை அறிக்கை",
  "about": "எங்களைப் பற்றி", 
  "contact": "தொடர்பு",
  "get_reading": "ஜோதிடம் பெறுங்கள்",
  "unlock_destiny": "உங்கள் விதியைத் திறக்கவும்",
  "language": "மொழி",
  
  // Core Horoscope
  "core_horoscope": "முக்கிய ஜாதகம்",
  "birth_chart": "பிறப்பு அட்டவணை / குண்டலி",
  "match_kundli": "குண்டலி பொருத்தம்",
  "ascendant_analysis": "லக்னம் பகுப்பாய்வு",
  "gochar_phal": "கோச்சார பலன்",
  "dasha_analysis": "தசா பல பகுப்பாய்வு",
  "nakshatra_report": "நட்சத்திர அறிக்கை",
  "numerology": "எண்ணியல்",
  
  // Life Predictions
  "life_predictions": "வாழ்க்கை கணிப்புகள்",
  "your_life_predictions": "உங்கள் வாழ்க்கை கணிப்புகள்",
  "2025_report": "2025 தனிப்பட்ட அறிக்கை",
  "year_analysis": "ஆண்டு பகுப்பாய்வு",
  "daily_horoscope": "இன்றைய எனது நாள்",
  "love_compatibility": "உங்கள் காதல் வாழ்க்கை",
  "career_guidance": "தொழில் வழிகாட்டுதல்",
  "nature_analysis": "உங்கள் உண்மையான இயல்பு",
  "health_index": "ஆரோக்கிய குறியீடு",
  
  // Remedial Solutions
  "remedial_solutions": "பரிகார தீர்வுகள்",
  "lal_kitab": "லால் கிதாப் ஜாதகம்",
  "mangal_dosha": "மங்கள தோஷம் பகுப்பாய்வு",
  "kalsarp_dosh": "கால சர்ப்ப தோஷம் அறிக்கை",
  "sade_sati": "சனி சாடேசதி வாழ்க்கை அறிக்கை",
  "ask_question": "ஒரு கேள்வி கேளுங்கள்",
  "gemstones_report": "ரத்தினக்கல் அறிக்கை"
};

export default translations;
